(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jacobs-continuous-products')) {
    customElements.define(
      'jacobs-continuous-products',
      class extends HTMLElement {
        connectedCallback() {
          this.setupFrame = requestAnimationFrame(() => this.setup());
        }

        setup() {
          this.carousel = document.getElementById(
            this.getAttribute('target')
          );

          if (!this.carousel) return;

          this.controller = new AbortController();

          const options = {
            signal: this.controller.signal
          };

          this.motion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          );

          const area = this.carousel.parentElement;

          // Bij instelling 25: 45 pixels per seconde.
          this.speed = Math.max(
            5,
            Number(this.getAttribute('speed')) || 25
          ) * 1.8;

          this.direction = 1;
          this.hovering = false;
          this.dragging = false;
          this.visible = false;
          this.resumeAt = 0;
          this.previousTime = null;

          this.position = Math.abs(this.carousel.scrollLeft);
          this.lastWritten = this.position;

          this.isRTL =
            getComputedStyle(this.carousel).direction === 'rtl';

          const pauseBriefly = () => {
            this.resumeAt = performance.now() + 1500;
          };

          area.addEventListener(
            'pointerenter',
            (event) => {
              if (event.pointerType === 'mouse') {
                this.hovering = true;
              }
            },
            options
          );

          area.addEventListener(
            'pointerleave',
            () => {
              this.hovering = false;
            },
            options
          );

          area.addEventListener(
            'pointerdown',
            () => {
              this.dragging = true;
            },
            options
          );

          ['pointerup', 'pointercancel'].forEach((eventName) => {
            window.addEventListener(
              eventName,
              () => {
                if (this.dragging) {
                  this.dragging = false;
                  pauseBriefly();
                }
              },
              options
            );
          });

          ['wheel', 'keydown', 'click'].forEach((eventName) => {
            area.addEventListener(
              eventName,
              pauseBriefly,
              {
                ...options,
                passive: true
              }
            );
          });

          area.addEventListener(
            'focusout',
            pauseBriefly,
            options
          );

          window.addEventListener(
            'blur',
            () => {
              this.dragging = false;
              this.previousTime = null;
            },
            options
          );

          document.addEventListener(
            'visibilitychange',
            () => {
              this.previousTime = null;
            },
            options
          );

          this.observer = new IntersectionObserver(
            (entries) => {
              this.visible = entries[0].isIntersecting;
              this.previousTime = null;
            },
            {
              threshold: 0
            }
          );

          this.observer.observe(this.carousel);

          this.tick = (time) => {
            if (!this.isConnected) return;

            const elapsed = this.previousTime === null
              ? 0
              : Math.min((time - this.previousTime) / 1000, 0.05);

            this.previousTime = time;

            const carousel = this.carousel;
            const actualPosition = Math.abs(carousel.scrollLeft);

            const paused =
              this.motion.matches ||
              this.hovering ||
              this.dragging ||
              !this.visible ||
              document.hidden ||
              area.contains(document.activeElement) ||
              time < this.resumeAt;

            if (paused) {
              this.position = actualPosition;
              this.lastWritten = actualPosition;
            } else {
              const maxScroll =
                carousel.scrollWidth - carousel.clientWidth;

              if (maxScroll > 2) {
                if (Math.abs(actualPosition - this.lastWritten) > 2) {
                  this.position = actualPosition;
                }

                this.position = Math.min(
                  maxScroll,
                  Math.max(0, this.position)
                );

                this.position +=
                  this.speed * elapsed * this.direction;

                if (this.position >= maxScroll) {
                  this.position = maxScroll;
                  this.direction = -1;
                } else if (this.position <= 0) {
                  this.position = 0;
                  this.direction = 1;
                }

                carousel.scrollLeft = this.isRTL
                  ? -this.position
                  : this.position;

                this.lastWritten = Math.abs(carousel.scrollLeft);
              } else {
                this.position = actualPosition;
                this.lastWritten = actualPosition;
              }
            }

            this.animationFrame = requestAnimationFrame(this.tick);
          };

          this.animationFrame = requestAnimationFrame(this.tick);
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.setupFrame);
          cancelAnimationFrame(this.animationFrame);

          this.controller?.abort();
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
